// Angular
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { UrlsComponent } from './components/urls/urls.component';
import { MockLoginComponent } from './components/mocklogin/mocklogin.component';
import { HealthContainerComponent } from './containers/health/health.container';
import { CheckInContainerComponent } from './containers/check-in/checkin.container';
import { ErrorPageContainerComponent } from './containers/error-page/error-page.container';
import { LandingBackContainerComponent } from './modules/landing-page/landing-page-container/landing-page.container';
import { HealthCenterContainerComponent } from './modules/health-center/health-center-container/health-center.container';

import {
  ctcResolver,
  guestsResolver,
  contentResolver,
  oExpensesResolver,
  featureFlagsResolver,
  biometricInfoResolver,
  personalDetailResolver,
  guestCompletedResolver,
  pDetailContentResolver,
  governanceContentResolver,
  travelQuestionnaireResolver,
  boardingPassGuard,
  oExpensesNavigationGuard,
  loggedInGuestLoyaltyGuard,
  arrivalTimeNavigationGuard,
  confirmationNavigationGuard,
  cruiseDetailsNavigationGuard,
  arrivalTimeInvAppointmentGuard,
  reservationGuard,
  passengerCruiseSurveyResolver,
  cobrandInfoResolver,
} from './guards';

const routes: Routes = [
  {
    path: 'urls',
    pathMatch: 'full',
    component: UrlsComponent
  },
  {
    path: 'login',
    component: MockLoginComponent
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'selectforcheckin'
  },
  {
    path: 'selectforcheckin',
    resolve: {
      featureFlags: featureFlagsResolver
    },
    children: [
      {
        path: '',
        component: LandingBackContainerComponent,
        resolve: {
          content: contentResolver,
          pdetailContent: pDetailContentResolver,
          guests: guestsResolver,
          guestsCompleted: guestCompletedResolver,
          governanceContent: governanceContentResolver
        }
      }
    ],
    canActivate: [reservationGuard]
  },
  {
    path: 'guest',
    component: CheckInContainerComponent,
    children: [
      {
        path: 'guestdetails',
        pathMatch: 'full',
        loadChildren: () => import('./modules/guest-details/guest-details.module').then(m => m.GuestDetailsModule),
        resolve: {
          pDetailContent: pDetailContentResolver,
          pInfo: personalDetailResolver,
          biometrics: biometricInfoResolver,
          travelQuestionnaire: travelQuestionnaireResolver,
          passengerCruiseSurvey: passengerCruiseSurveyResolver
        },
        canActivate: [reservationGuard]
      },
      {
        path: 'onboardexpenses',
        pathMatch: 'full',
        loadChildren: () => import('./modules/onboard-expenses/onboard-expenses.module').then(m => m.OnboardExpensesModule),
        resolve: { oexpenses: oExpensesResolver },
        canActivate: [reservationGuard, oExpensesNavigationGuard]
      },
      {
        path: 'cruisedetails',
        pathMatch: 'full',
        loadChildren: () => import('./modules/cruise-details/cruise-details.module').then(m => m.CruiseDetailsModule),
        resolve: {
          ctc: ctcResolver,
          oexpenses: oExpensesResolver,
        },
        canActivate: [reservationGuard, cruiseDetailsNavigationGuard]
      },
      {
        path: 'arrivalinfo',
        pathMatch: 'full',
        loadChildren: () => import('./modules/arrival-info/arrival-info.module').then(m => m.ArrivalInfoModule),
        canActivate: [reservationGuard, arrivalTimeNavigationGuard, arrivalTimeInvAppointmentGuard]
      }
    ]
  },
  {
    path: 'confirmation',
    loadChildren: () => import('./modules/confirmation-page/confirmation.module').then(m => m.ConfirmationModule),
    resolve: {
      guestsCompleted: guestCompletedResolver
    },
    canActivate: [reservationGuard, loggedInGuestLoyaltyGuard, confirmationNavigationGuard]
  },
  {
    path: 'boardingpass',
    loadChildren: () => import('./modules/boarding-pass/boarding-pass.module').then(m => m.BoardingPassModule),
    resolve: {
          cobrandInfoRes: cobrandInfoResolver,
    },
    canActivate: [reservationGuard, boardingPassGuard]
  },
  // OLCI-8379 Health Check Page
  {
    path: 'health',
    component: HealthContainerComponent
  },
  {
    path: 'healthcenter',
    component: HealthCenterContainerComponent
  },
  {
    path: 'error',
    component: ErrorPageContainerComponent
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'error'
  }
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
